import React from 'react';
import PortfolioCard from './PortfolioCard';
import Icon from '../../../components/AppIcon';

const PortfolioGrid = ({ companies, onViewDetails, loading }) => {
  if (loading) {
    return (
      <section className="bg-background py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)]?.map((_, index) => (
              <div key={index} className="bg-card border border-border rounded-brand p-6 animate-pulse">
                <div className="h-48 bg-muted rounded-brand-sm mb-4"></div>
                <div className="space-y-3">
                  <div className="h-4 bg-muted rounded w-3/4"></div>
                  <div className="h-3 bg-muted rounded w-1/2"></div>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="h-16 bg-muted rounded-brand-sm"></div>
                    <div className="h-16 bg-muted rounded-brand-sm"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (companies?.length === 0) {
    return (
      <section className="bg-background py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center py-16">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Search" size={24} className="text-muted-foreground" />
            </div>
            <h3 className="text-xl font-semibold text-foreground mb-2">No companies found</h3>
            <p className="text-muted-foreground mb-6">
              Try adjusting your filters to see more portfolio companies.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-background py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl font-bold text-foreground mb-2">
              Portfolio Companies
            </h2>
            <p className="text-muted-foreground">
              Showing {companies?.length} companies
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <div className="hidden sm:flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="TrendingUp" size={16} />
              <span>Sorted by performance</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {companies?.map((company, index) => (
            <div
              key={company?.id}
              className="scroll-reveal"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <PortfolioCard
                company={company}
                onViewDetails={onViewDetails}
              />
            </div>
          ))}
        </div>

        {/* Load More Section */}
        {companies?.length >= 9 && (
          <div className="text-center mt-12">
            <p className="text-muted-foreground mb-4">
              Showing {companies?.length} of {companies?.length + 12} companies
            </p>
            <button className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground rounded-brand hover:bg-primary/90 transition-brand">
              <span>Load More Companies</span>
              <Icon name="ChevronDown" size={16} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PortfolioGrid;